import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface OccurrencePrefill {
  lat: string;
  lon: string;
  concentration: number;
  threshold: number;
  layerIndex: number;
  layerColor: string;
  pollutant: string;
  timebase: string;
  startDate: string;
  endDate: string;
  facilityID: string;
  facilityPos: number;
  emissionSources: any[];
}

interface OccurrenceState {
  occurrenceUpdated: boolean;
  prefillData: OccurrencePrefill | null;
  openFromPlume: boolean;
}

const initialState: OccurrenceState = {
  occurrenceUpdated: false,
  prefillData: null,
  openFromPlume: false,
};

const occurrenceSlice = createSlice({
  name: "occurrence",
  initialState,
  reducers: {
    setOccurrenceUpdated: (state, action: PayloadAction<boolean>) => {
      state.occurrenceUpdated = action.payload;
    },
    setPrefillData: (state, action: PayloadAction<OccurrencePrefill | null>) => {
      state.prefillData = action.payload;
    },
    setOpenFromPlume: (state, action: PayloadAction<boolean>) => {
      state.openFromPlume = action.payload;
    },
  },
});

export const { setOccurrenceUpdated, setPrefillData, setOpenFromPlume } =
  occurrenceSlice.actions;

export default occurrenceSlice.reducer;
